import React, {useState} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {
    AppBar,
    Card,
    CardContent,
    Grid,
    Icon,
    IconButton,
    TextField,
    Toolbar,
    Typography,
    Switch
} from '@material-ui/core'
import {withRouter} from "react-router-dom"
import ReduxMedical from "../../../../../store/actionreducers/adminMedical/medical"
import ReduxGlobal from "../../../../../store/actionreducers/globalView"
import {withStyles} from "@material-ui/core/styles"

const hasBreak = note => {
    return note.split('\n').map((item, key) => {
            return <span key={key}>
                {item}
                <br/>
            </span>
        }
    )
}

const numberOfRowsInTextField = 7

const ExperienceTab = ({medical, updateMedical, openAlertDialog, openLoadingMask, closeLoadingMask}) => {

    const [actionType, setActionType] = useState('view') // view and edit

    const [degree, setDegree] = useState(medical.degree)
    const [specialist, setSpecialist] = useState(medical.specialist)
    const [expertise, setExpertise] = useState(medical.expertise)
    const [experience, setExperience] = useState(medical.experience)
    const [achievement, setAchievement] = useState(medical.achievement)
    const [publish, setPublish] = useState(medical.publish)

    const [show, setShow] = useState(!!medical.medical_liability_insurance)
    const [medicalLiabilityInsurance, setMedicalLiabilityInsurance] = useState(parseInt(medical.medical_liability_insurance, 10).toLocaleString())

    const data = [
        {title: '學歷', message: medical.degree},
        {title: '專科', message: medical.specialist},
        {title: '專長', message: medical.expertise},
        {title: '經歷', message: medical.experience},
        {title: '特殊成就', message: medical.achievement},
        {title: '重要發表或文獻', message: medical.publish},
        {title: '醫責險', message: parseInt(medical.medical_liability_insurance, 10).toLocaleString()}
    ]

    if (actionType === 'view') {
        return <div>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            個人簡介設定
                        </Typography>
                        <IconButton
                            onClick={() => {
                                setActionType('edit')
                            }}
                        >
                            <Icon className="text-white">mode_edit</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <CardContent className="flex flex-col flex-wrap h-288">
                    {
                        data.map((dt, index) => (
                            <div className="mb-16" key={`medical_info-${index}`}>
                                <Typography className="font-bold mb-4 text-15">{dt.title}</Typography>
                                <Typography>{dt.message ? hasBreak(dt.message) : '無資料' }</Typography>
                            </div>
                        ))
                    }
                </CardContent>
            </Card>
        </div>
    } else {
        return <div>
            <Card className="w-full h-full mb-24 bg-grey-lighter">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            個人簡介設定
                        </Typography>
                        <IconButton
                            onClick={async () => {
                                openLoadingMask()
                                try {
                                    await updateMedical({
                                        medical: {
                                            id: medical.id,
                                            degree,
                                            specialist,
                                            expertise,
                                            experience,
                                            achievement,
                                            publish,
                                            medical_liability_insurance:
                                                (show && medicalLiabilityInsurance.replaceAll(',', ''))
                                                || null,
                                        }
                                    })
                                    setActionType('view')
                                } catch (e) {
                                    console.warn('error while updating medical', e)
                                }
                                closeLoadingMask()
                            }}
                        >
                            <Icon className="text-white">save</Icon>
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                const alertDialogInfo = {
                                    title: '離開編輯畫面',
                                    message: `若您尚未儲存，您所填寫的資料將會遺失，請問您是否要離開?`,
                                    yesButton: {
                                        label: '是',
                                        onClick: () => {
                                            setActionType('view')
                                        },
                                    },
                                    noButton: {label: '否'}
                                }
                                openAlertDialog(alertDialogInfo)

                            }}
                        >
                            <Icon className="text-white">cancel</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <CardContent className="flex flex-col flex-wrap max-w-md">
                    <div className="p-8 mb-36">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            學歷
                        </Typography>
                        <textarea
                            className="flex w-full text-16 p-10"
                            value={degree || ''}
                            onChange={event => setDegree(event.target.value)}
                            rows={numberOfRowsInTextField}
                            style={styles().textArea}
                        />
                    </div>
                    <div className="p-8 mb-32">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            專科
                        </Typography>
                        <textarea
                            className="flex w-full text-16 p-10"
                            value={specialist || ''}
                            onChange={event => setSpecialist(event.target.value)}
                            rows={numberOfRowsInTextField}
                            style={styles().textArea}
                        />
                    </div>
                    <div className="p-8 mb-32">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            專長
                        </Typography>
                        <textarea
                            className="flex w-full text-16 p-10"
                            value={expertise || ''}
                            onChange={event => setExpertise(event.target.value)}
                            rows={numberOfRowsInTextField}
                            style={styles().textArea}
                        />
                    </div>
                    <div className="p-8 mb-32">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            經歷
                        </Typography>
                        <textarea
                            className="flex w-full text-16 p-10"
                            value={experience || ''}
                            onChange={event => setExperience(event.target.value)}
                            rows={numberOfRowsInTextField}
                            style={styles().textArea}
                        />
                    </div>
                    <div className="p-8 mb-32">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            特殊成就
                        </Typography>
                        <textarea
                            className="flex w-full text-16 p-10"
                            value={achievement || ''}
                            onChange={event => setAchievement(event.target.value)}
                            rows={numberOfRowsInTextField}
                            style={styles().textArea}
                        />
                    </div>
                    <div className="p-8 mb-32">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            重要發表或文獻
                        </Typography>
                        <textarea
                            className="flex w-full text-16 p-10"
                            value={publish || ''}
                            onChange={event => setPublish(event.target.value)}
                            rows={numberOfRowsInTextField}
                            style={styles().textArea}
                        />
                    </div>
                    <div className="p-8 mb-32 flex-row">
                        <Typography className="font-bold pl-18 mb-8 text-20">
                            是否有提供醫責險
                        </Typography>

                        <Grid component="label" container alignItems="center" spacing={0}>
                            <Grid item>
                                <Typography component="div">
                                    <Grid component="label" container alignItems="center" spacing={0}>
                                        <Grid item>否</Grid>
                                        <Grid item>
                                            <Switch checked={show} onChange={event => setShow(event.target.checked)}/>
                                        </Grid>
                                        <Grid item>是</Grid>
                                    </Grid>
                                </Typography>
                            </Grid>
                            { show &&
                            <Grid className="pl-32">
                                <TextField
                                    label={'醫責險(NTD)'}
                                    value={medicalLiabilityInsurance || ''}
                                    onChange={event => {
                                        let value = event.target.value
                                        const formatNumber = parseInt(value.replaceAll(',', ''), 10).toLocaleString()
                                        setMedicalLiabilityInsurance(formatNumber)
                                    }}
                                />
                            </Grid>}
                        </Grid>
                    </div>
                </CardContent>
            </Card>
        </div>
    }
}

const styles = () => ({
    textArea: {
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 10,
        lineHeight: 2.0,
        padding: 20,
        resize: "none",
        overflow: "hidden",
    },
})


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateMedical: ReduxMedical.ActionCreator.updateMedical,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
    }, dispatch)
}


function mapStateToProps({adminMedicalList: {medical}}) {
    return {
        medical
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(ExperienceTab)))



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/tabs/ExperienceTab.js